import React from "react";
import ChildHeaderLayout from "./childHeaderLayout";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";
import config from "configs/config";
import Skeleton from "@mui/material/Skeleton";
import { useParams } from "react-router-dom";

const SubStockChildLayoutWraaper = () => {

  const {set} = useParams();
  console.log("Stage 1")  

  const isLoading = false; 

  if (isLoading) {
    return <Skeleton animation="wave" height={60} width="20%" sx={{ margin: 0, padding: 0, marginLeft: "20px" }} />;
  }

  return <ChildHeaderLayout pageName={set} />;
};

export default SubStockChildLayoutWraaper;
